import type { ReactNode } from 'react'
import * as RadixTooltip from '@radix-ui/react-tooltip'
import { cn } from '@/lib/cn'

export function TooltipProvider({ children }: { children: ReactNode }) {
  return <RadixTooltip.Provider delayDuration={300}>{children}</RadixTooltip.Provider>
}

export interface TooltipProps {
  content: ReactNode
  children: ReactNode
  className?: string
}

/** Standard hover/focus tooltip for icon buttons and truncated labels (not chart tooltips). */
export function Tooltip({ content, children, className }: TooltipProps) {
  return (
    <RadixTooltip.Root>
      <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
      <RadixTooltip.Portal>
        <RadixTooltip.Content
          sideOffset={6}
          className={cn(
            'z-50 rounded-sm border border-line bg-surface-pop px-2.5 py-1.5 text-caption text-ink shadow-pop',
            className,
          )}
        >
          {content}
          <RadixTooltip.Arrow className="fill-surface" />
        </RadixTooltip.Content>
      </RadixTooltip.Portal>
    </RadixTooltip.Root>
  )
}
